import { render, staticRenderFns } from "./NoTicketGroupAvailable.vue?vue&type=template&id=459f418f"
import script from "./NoTicketGroupAvailable.vue?vue&type=script&lang=js"
export * from "./NoTicketGroupAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports